import { render, staticRenderFns } from "./LoaderLight.vue?vue&type=template&id=dce3317e&scoped=true&"
import script from "./LoaderLight.vue?vue&type=script&lang=js&"
export * from "./LoaderLight.vue?vue&type=script&lang=js&"
import style0 from "./LoaderLight.vue?vue&type=style&index=0&id=dce3317e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce3317e",
  null
  
)

export default component.exports